import * as React from 'react';
import { IAccordionProps } from './IAccordion';

const Accordion = (props: IAccordionProps) => {
    let target = `target_${props.title.replaceAll(' ', '').replaceAll(':', '').replaceAll(',', '').replaceAll('.', '')}`;
    let labelledBy = `labelledBy_${props.title.replaceAll(' ', '')}`;
    return (
        <div className='accordion'>
            <div className='accordion-item' key={target}>
                <h2 className='accordion-header' id={labelledBy}>
                    <button className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target={`#${target}`} aria-expanded='true' aria-controls={target}>
                        {props.title}
                    </button>
                </h2>
                <div id={target} className='accordion-collapse collapse' aria-labelledby={labelledBy}>
                    <div className='accordion-body'>{props.children}</div>
                </div>
            </div>
        </div>
    );
};

export default Accordion;
